import {Injectable} from "@angular/core";
import {ApiService} from "../../../services/api.service";
import {SearchIDsCriteriaDto} from "../../../models/search-ids-criteria-dto"
import {NonprofitsDonorsDetailsSearchDto} from "../../../models/nonprofits-donors-details-search-dto";
import {SearchGrantsFilterDto} from "../../../models/search-grants-filter-dto";


@Injectable()
export class SearchGrantsService {
  constructor(private apiService: ApiService) {}

  contextApi = '/api';

  public getNonprofits(filterParam: SearchIDsCriteriaDto, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits?loggedInUsername=' + username,
      false,
      true,
      {"filterParam": filterParam},
      null,
      false,
      null
    );
  }

  public getNonprofitDonorFullAttributes(nonprofitDonorId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/nonprofits-donors/' + nonprofitDonorId + '/full-attributes?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getDonors(filterParam: SearchIDsCriteriaDto, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors?loggedInUsername=' + username,
      false,
      true,
      {"filterParam": filterParam},
      null,
      false,
      null
    );
  }

  public getDonorDetails(filterParam: NonprofitsDonorsDetailsSearchDto, donorId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors/'+ donorId +'/details?loggedInUsername=' + username,
      false,
      true,
      {"filterParam": filterParam},
      null,
      false,
      null
    );
  }

  public getDonorIRSTaxReturnPDFs(donorId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors/'+ donorId +'/details/irs-tax-return-pdfs?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getDonorDetailsRecipients(donorDetailsId: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/donors/donor-details/'+ donorDetailsId +'/recipients?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getGrants(filterParam: SearchGrantsFilterDto, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/overview?loggedInUsername=' + username,
      false,
      true,
      {"filterParam": filterParam},
      null,
      false,
      null
    );
  }

  public getGrantsPages(filterParam: SearchGrantsFilterDto, updatePageValue: number, pageSize: number , username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/pages/overview',
      false,
      true,
      {
        "loggedInUsername": username,
        "filterParam": filterParam,
        "page": updatePageValue,
        "pageSize": pageSize
      },
      null,
      false,
      null
    );
  }

  public getGrantsInExcel(filterParam: SearchGrantsFilterDto, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/overview/export/excel?loggedInUsername=' + username,
      false,
      true,
      {"format": "CSV",
        "filterParam": filterParam},
      {responseType: "blob"},
      false,
      null
    );
  }

  public getGrantsPagesInExcel(filterParam: SearchGrantsFilterDto, page: number, pageSize: number, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/pages/overview/export/excel',
      false,
      true,
      {"format": "CSV",
        "page": page,
        "pageSize": pageSize,
        "filterParam": filterParam,
        "loggedInUsername": username
      },
      {responseType: "blob"},
      false,
      null
    );
  }

  public searchDonorRecipientDetails(donorRecipientMappingId: string, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/'+ donorRecipientMappingId +'/details?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public searchDonorDetails(donorDetailsId: string, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/donors/donor-details/'+ donorDetailsId +'?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public searchDonorOverview(donorId: string, username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/search/grants/donors/' + donorId + '/overview?loggedInUsername=' + username,
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getTaxYearsDropdown(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/tax-years',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getUSAStatesDropdown(): any {
    return this.apiService.getCall(
      this.contextApi + '/public/dropdown/states',
      false,
      false,
      null,
      null,
      false,
      null
    );
  }

  public getRecipientsDropdown(): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/recipient-company-names',
      false,
      true,
      null,
      null,
      false,
      null
    );
  }

  public getCausesDropdown(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/causes',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getGrantsCities(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/grants/cities',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }

  public getGrantsRecipientNames(username: string): any {
    return this.apiService.getCall(
      this.contextApi + '/protected/dropdown/grants/company-names',
      false,
      true,
      {
        "loggedInUsername": username
      },
      null,
      false,
      null
    );
  }
}
